<ion-footer class="ion-no-border">
    <ion-button *ngIf="!hideSubmit" data-cy="footer-submit-button" color="dark" class="footer-button" (click)="submitButtonClicked()"
                [disabled]="disableSubmit">
        {{submitLabel}}
    </ion-button>
</ion-footer>
